import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProfileComponent from '../Components/ProfileComponent';

import { notifications as notificationsActions } from '../actions';
import { notificationRequestsByRuleId } from '../reducers';
import { storage } from '../helpers';

export class ProfileContainer extends Component {
  static propTypes = {
    notificationRequests: PropTypes.any.isRequired,
    fetchNotificationRequests: PropTypes.func.isRequired,
    fetchNotificationRules: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchNotificationRequests();
    this.props.fetchNotificationRules();
  }

  render() {
    return (
      <div>
        <ProfileComponent />
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return { notificationRequests: notificationRequestsByRuleId(state) };
};

export const mapDispatchToProps = (dispatch) => {
  const userEmail = localStorage.getItem(storage.EMAIL_KEY);
  return {
    fetchNotificationRequests: () =>
      dispatch(notificationsActions.fetchNotificationRequests(userEmail)),
    fetchNotificationRules: () =>
      dispatch(notificationsActions.fetchNotificationRules())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileContainer);


// WEBPACK FOOTER //
// src/Containers/ProfileContainer.jsx